import { createContext, useContext } from "react";
import type { Me } from "./api";

// Who's signed in, for screens deep in the app (the workspace's top bar shows a student's class and
// hides teacher-only buttons). App provides it once /api/me has loaded.
export const MeContext = createContext<Me | null>(null);
export const useMe = () => useContext(MeContext);
export const isStudent = (me: Me | null) => me?.user.role === "student";

// Re-reads a student's helper coins after a helper turn (App provides it). A failed read keeps the
// last count; the coins are a convenience, not a gate.
export const RefreshCoinsContext = createContext<() => void>(() => {});
export const useRefreshCoins = () => useContext(RefreshCoinsContext);
